import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getOpportunitySchedule,
  listWorkspaceOpportunitySchedules,
  removeWorkspaceOpportunitySchedule,
  updateOpportunitySchedule,
  updateWorkspaceOpportunitySchedule,
} from '../api/opportunity-schedule.api';

/**
 * Exported because saving a tool configuration creates the workspace's job row as a side effect,
 * so the surfaces that save one have to invalidate this list to see the schedule it just gained.
 */
export const WORKSPACE_SCHEDULES_KEY = ['workspaceOpportunitySchedules'];

export const useOpportunitySchedule = () => {
  return useQuery({
    queryKey: ['opportunitySchedule'],
    queryFn: () => getOpportunitySchedule(),
  });
};

export const useUpdateOpportunitySchedule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateOpportunitySchedule,
    onSuccess: (data) => {
      // Update the cache with the correct query key
      queryClient.setQueryData(['opportunitySchedule'], data);
      // Every inheriting workspace just changed its effective schedule.
      void queryClient.invalidateQueries({ queryKey: WORKSPACE_SCHEDULES_KEY });
    },
  });
};

export const useWorkspaceOpportunitySchedules = () => {
  return useQuery({
    queryKey: WORKSPACE_SCHEDULES_KEY,
    queryFn: () => listWorkspaceOpportunitySchedules(),
  });
};

export const useUpdateWorkspaceOpportunitySchedule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateWorkspaceOpportunitySchedule,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: WORKSPACE_SCHEDULES_KEY });
    },
  });
};

export const useRemoveWorkspaceOpportunitySchedule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: removeWorkspaceOpportunitySchedule,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: WORKSPACE_SCHEDULES_KEY });
    },
  });
};
